// App.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './HomePage';    // 기존 Main/Home
import About from './About'; // 새로 만든 About 페이지

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* "/about" 라우트 -> About 컴포넌트 */}
      <Route path="/about" element={<About />} />
      {/* 추후 "/services", "/contact" 등을 라우팅으로 더 분리하고 싶다면 같은 방식으로 추가 */}
    </Routes>
  );
}
